import {
    applyMiddleware,
    createStore,
    compose,
    combineReducers
} from 'redux';
import { reducers } from 'services/root-reducer';
import { serviceRunner, initServices } from 'services';
import { sagaMiddleware, middleware, LocalStorageSync } from './middleware';

const actionSanitizer = action => (
    action.type === 'OMJS_SET_VIEW_INSTANCE' && action.data
        ? { ...action, data: '<<OMJS_VIEW_INSTANCE>>' }
        : action
);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.call(window, {
    actionSanitizer,
    stateSanitizer: state => (state.omjs.omjsViewInstance ? {
        ...state,
        omjs: {
            ...state.omjs,
            omjsViewInstance: '<<OMJS_VIEW_INSTANCE>>'
        }
    } : state)
}) ?? compose;

const rootReducer = combineReducers(reducers);

const configStore = (initialState: object = {}) => {
    const store = createStore(
        rootReducer,
        initialState,
        composeEnhancer(applyMiddleware(...middleware))
    );

    sagaMiddleware.run(serviceRunner);
    return { store };
};

const { store } = configStore(LocalStorageSync.restoreStore());

const runService = function(service) {
    store.dispatch({ 'type': 'RUN_SERVICE', 'payload': service });
};

const runInitServices = () => {
    for (let service of initServices) {
        service.start();
    }
};

export {
    store, runService, runInitServices
};
